var _path, _circle, _mask, _rect, _line, _mask2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLisColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10567 14.3878C4.68568 13.6992 4.714 12.8849 4.68568 12.164C4.63501 10.8745 4.90314 9.59243 5.46632 8.43131C6.0295 7.27019 6.78499 6.30541 6.97639 6.11401L9.27315 7.83659C8.69896 8.41078 8.38109 8.92989 8.02174 9.67077C7.66239 10.4116 7.49131 11.2297 7.52364 12.0525C7.55597 12.8753 7.79071 13.6774 8.20709 14.3878C8.62346 15.0982 9.20861 15.695 9.9107 16.1252C10.6128 16.5554 11.4101 16.8059 12.2321 16.8544C13.0541 16.9028 13.8754 16.7478 14.6232 16.4031C15.371 16.0584 16.0222 15.5345 16.5192 14.878C17.0162 14.2214 17.183 13.8176 17.3118 13.0043L20.2776 13.0835C20.0757 14.3581 19.5626 15.5632 18.7837 16.5922C18.0048 17.6211 16.9842 18.4421 15.8123 18.9824C14.6403 19.5226 13.3532 19.7656 12.065 19.6896C10.7767 19.6136 9.52706 19.2211 8.42673 18.5468C8.10985 18.3527 7.80818 18.1368 7.52364 17.9013",
    stroke: "#F6A447",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.21077,
    cy: 16.2582,
    r: 1.54676,
    stroke: "#F6A447",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_9787_83492",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.13007,
    width: 11.4838,
    height: 4.05082,
    rx: 1,
    transform: "rotate(35.7158 5.13007 0)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.13007,
    width: 11.4838,
    height: 4.05082,
    rx: 1,
    transform: "rotate(35.7158 5.13007 0)",
    stroke: "#F6A447",
    strokeWidth: 3,
    mask: "url(#path-3-inside-1_9787_83492)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.015,
    y1: 12.4458,
    x2: 22.2881,
    y2: 12.4458,
    stroke: "#F6A447",
    strokeWidth: 1.5
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_9787_83492",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 21.5C2 20.6716 2.67157 20 3.5 20H20.5C21.3284 20 22 20.6716 22 21.5H2Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21.5H20.5V18.5H3.5V21.5ZM22 20H2V23H22V20ZM20.5 21.5H23.5C23.5 19.8431 22.1569 18.5 20.5 18.5V21.5ZM3.5 18.5C1.84315 18.5 0.5 19.8431 0.5 21.5H3.5H3.5V18.5Z",
    fill: "#F6A447",
    mask: "url(#path-5-inside-2_9787_83492)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17L5 20",
    stroke: "#F6A447",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLisColor);
export default __webpack_public_path__ + "static/media/LisColor.b056c316.svg";
export { ForwardRef as ReactComponent };